import { render, staticRenderFns } from "./AuditarAtencion.vue?vue&type=template&id=92a52224"
import script from "./AuditarAtencion.vue?vue&type=script&lang=js"
export * from "./AuditarAtencion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports